import AddPhotoIcon from '@mui/icons-material/AddPhotoAlternate'

const Icon = () => {
  return (
    <AddPhotoIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
